module.exports = __webpack_public_path__ + "static/media/soft_cod4u_2.375e209f.jpg";